import * as AI from '@microsoft/applicationinsights-web';
import { guid } from '../Shared/guid';
import { asCuppSchema, EventType, } from '@employee-experience/common/lib/Models/UsageTelemetry';
import { deviceDetect } from 'react-device-detect';
export class TelemetryClient {
    constructor(config, correlationId, appInsights) {
        this.correlationId = correlationId || guid();
        if (!appInsights) {
            appInsights = new AI.ApplicationInsights({
                config: config,
            });
            const deviceInfo = deviceDetect(window.navigator.userAgent);
            appInsights.loadAppInsights();
            appInsights.addTelemetryInitializer((item) => {
                var _a;
                item.data = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, item.data), { correlationId: this.correlationId, location: window.location.href.split('#')[0], telemetrySource: 'UI' }), config.UTPConfig), config.defaultProperties), deviceInfo);
                if (item.data) {
                    item.data = asCuppSchema(item.data);
                }
                if ((_a = item.baseData) === null || _a === void 0 ? void 0 : _a.properties) {
                    item.baseData.properties = asCuppSchema(item.baseData.properties);
                }
            });
        }
        this.appInsights = appInsights;
        this.config = config;
    }
    trackPageView(pageView) {
        this.appInsights.trackPageView(pageView);
    }
    startTrackPage(name) {
        this.appInsights.startTrackPage(name);
    }
    trackPageViewPerformance(pageViewPerformance) {
        this.appInsights.trackPageViewPerformance(pageViewPerformance);
    }
    trackEvent(event, customProperties) {
        var _a;
        const usageEvent = (_a = this.telemetryContext) === null || _a === void 0 ? void 0 : _a.setUsageEvent(event);
        this.appInsights.trackEvent(Object.assign(Object.assign({}, event), usageEvent), Object.assign(Object.assign({}, usageEvent), customProperties));
    }
    trackCustomEvent(event, customProperties) {
        this.appInsights.trackEvent(Object.assign({}, event), customProperties);
    }
    setAuthenticatedUserContext(authenticatedUserId, accountId, storeInCookie) {
        this.appInsights.setAuthenticatedUserContext(authenticatedUserId, accountId, storeInCookie);
    }
    trackException(exception) {
        var _a;
        try {
            const emptyEvent = {
                type: EventType.System,
                experienceResult: false,
            };
            exception.properties = (_a = this.telemetryContext) === null || _a === void 0 ? void 0 : _a.setUsageEvent(emptyEvent);
        }
        catch (error) {
            // Ignore error and log the exception as is.
        }
        this.appInsights.trackException(exception);
    }
    _onerror(exception) {
        this.appInsights._onerror(exception);
    }
    trackTrace(trace, customProperties) {
        this.appInsights.trackTrace(trace, customProperties);
    }
    trackMetric(metric, customProperties) {
        this.appInsights.trackMetric(metric, customProperties);
    }
    stopTrackPage(name, url, customProperties) {
        this.appInsights.stopTrackPage(name, url, customProperties);
    }
    startTrackEvent(name) {
        var _a;
        if (typeof name === 'string') {
            this.appInsights.startTrackEvent(name);
        }
        if (typeof name !== 'string') {
            const eventName = 'eventName' in name ? (name.eventName || 'PageLoad') + 'Start' : 'PageLoadStart';
            const startEvent = Object.assign(Object.assign({}, name), { eventName });
            const event = (_a = this.telemetryContext) === null || _a === void 0 ? void 0 : _a.setUsageEvent(startEvent);
            this.appInsights.startTrackEvent(event.name);
            return event;
        }
    }
    // eslint-disable-next-line prettier/prettier
    stopTrackEvent(name, properties, measurements) {
        var _a;
        if (typeof name === 'string') {
            this.appInsights.stopTrackEvent(name, properties, measurements);
        }
        else {
            const telemetryProps = Object.assign(Object.assign({}, (name || {})), (properties || {}));
            const e = (_a = this.telemetryContext) === null || _a === void 0 ? void 0 : _a.setUsageEvent(Object.assign({}, name));
            const event = Object.assign(Object.assign({}, telemetryProps), e);
            this.appInsights.stopTrackEvent(event.name, event, measurements);
            return event;
        }
    }
    trackDependencyData(dependency) {
        this.appInsights.trackDependencyData(dependency);
    }
    addTelemetryInitializer(telemetryInitializer) {
        this.appInsights.addTelemetryInitializer(telemetryInitializer);
    }
    getChildInstance(config, correlationId, telemetryContext) {
        const childClient = new TelemetryClient(config || this.config, correlationId || this.correlationId, this.appInsights);
        if (telemetryContext) {
            childClient.setContext(telemetryContext);
        }
        return childClient;
    }
    setContext(telemetryContext) {
        this.telemetryContext = telemetryContext;
    }
    getCorrelationId() {
        return this.correlationId;
    }
}
//# sourceMappingURL=TelemetryClient.js.map